import PropTypes from 'prop-types';
import React from 'react';
import FormWrapContext, { FormControlGroupWrapContext, FormItemGroupWrapContext } from '../tools/FormWrapContext';
export default function PortalContext(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(FormWrapContext.StandAlone, null, /*#__PURE__*/React.createElement(FormControlGroupWrapContext.StandAlone, null, /*#__PURE__*/React.createElement(FormItemGroupWrapContext.StandAlone, null, children)));
}
PortalContext.propTypes = {
  children: PropTypes.node
};
PortalContext.defaultProps = {
  children: null
};